import { render, staticRenderFns } from "./SendMailTemplateShow.vue?vue&type=template&id=12bd13ed&scoped=true&"
import script from "./SendMailTemplateShow.vue?vue&type=script&lang=js&"
export * from "./SendMailTemplateShow.vue?vue&type=script&lang=js&"
import style0 from "./SendMailTemplateShow.vue?vue&type=style&index=0&id=12bd13ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd13ed",
  null
  
)

export default component.exports